import React from 'react';

import Layout from '../components/shared/layout';

import Store from '../components/store';

const CategoryStore = ({ pageContext }) => (
  <Layout>
    <Store seoActivated title={pageContext.categoryName} />
  </Layout>
);

export default CategoryStore;
